import PropTypes from 'prop-types';
import styles from './SingleRifle.module.css';

const SingleRifle = ({title, category, price, tag, image, icon}) => {
    return (
        <div className={styles.SingleRifle}>
            <div className={styles.contentWrapper}>
                <div className={styles.content}>
                    <div className={styles.imgWrapper}>
                        <img src={image} alt="" />
                    </div>
                    <h4>{title}</h4>
                    <p>{category}</p>
                    <h6>Kr {price}</h6>
                </div>
                <div className={styles.hover}>
                    <p className={`${tag === 'new' ? 'yellow' : 'green'} text-capitalize`}>{tag}</p>
                    <p className={styles.fav}>
                        <img src={icon} alt="" />
                    </p>
                </div>
            </div>
        </div>
    );
};

export default SingleRifle;

// type checking 
SingleRifle.propTypes = {
    title: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
    price: PropTypes.string.isRequired,
    tag: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
}